var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShippingIcon = function SvgShippingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.028 13.722a1.187 1.187 0 1 1-1.678 1.68 1.187 1.187 0 0 1 1.678-1.68M5.778 13.722a1.187 1.187 0 1 1-1.678 1.68 1.187 1.187 0 0 1 1.678-1.68M7.5 3h3a.75.75 0 0 1 .75.75v7.5H1.5",
    stroke: "#2F4DA1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.562h-1.5a.75.75 0 0 1-.75-.75V9.75M11.25 5.25h3.242c.307 0 .583.187.696.472l1.205 3.01c.07.177.107.366.107.557v4.46a.75.75 0 0 1-.75.75h-1.373M12 14.565H6.128",
    stroke: "#2F4DA1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5h-3v-3h2.4M1.5 3h3.75M1.5 5.25h2.25M2.25 7.5H1.5",
    stroke: "#2F4DA1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgShippingIcon;